import 'swiper/css'

import Swiper from 'swiper'
import { A11y, Navigation } from 'swiper/modules'

const syncGalleryState = (swiper, gallery) => {
  const caption = gallery.querySelector('[data-gallery-caption]')
  const current = gallery.querySelector('[data-gallery-current]')
  const total = gallery.querySelector('[data-gallery-total]')
  const activeSlide = swiper.slides[swiper.activeIndex]

  if (caption && activeSlide) {
    caption.textContent = activeSlide.dataset.caption || ''
  }

  if (current) {
    current.textContent = String(swiper.realIndex + 1)
  }

  if (total) {
    total.textContent = String(swiper.slides.length)
  }
}

export const initGallerySliders = () => {
  document.querySelectorAll("[data-swiper='gallery']").forEach((gallery) => {
    const section = gallery.closest('.gallery') || gallery.parentElement
    const prevEl = section.querySelector('[data-gallery-prev]')
    const nextEl = section.querySelector('[data-gallery-next]')

    const swiper = new Swiper(gallery, {
      modules: [A11y, Navigation],
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      navigation: {
        prevEl,
        nextEl,
      },
      on: {
        init(instance) {
          syncGalleryState(instance, section)
        },
        slideChange(instance) {
          syncGalleryState(instance, section)
        },
      },
    })

    syncGalleryState(swiper, section)
  })
}
